import createReducer from '../../../store/createReducer';

export const initialState = {
    workshopsById: {},
    workshops: []
};

export default createReducer(initialState, {});
